import React from 'react';

import { LazyImage, Modal, Spinner, useDevice } from '@tecma/ds';

import usePreventBodyScroll from 'hooks/usePreventBodyScroll';

import { SwiperCarousel } from 'components/SwiperCarousel';

import type { SwiperController } from 'hooks/useSwiperController';

import './modal-image-container.scss';

interface ModalImageContainerRequiredProps {
  isOpen: boolean;
  onClose: () => void;
  images: string | string[];
  next: () => void;
  prev: () => void;
  carouselImageIndex: number;
  setCarouselImageIndex: (index: number) => void;
}

// Optional Props
interface ModalImageContainerOptionalProps {
  swiperController?: SwiperController;
}

// Combined required and optional props to build the full prop interface
export interface ModalImageContainerProps extends ModalImageContainerRequiredProps, ModalImageContainerOptionalProps {}

const getCarouselItems = (items: string[]) => {
  return items.map((img) => <LazyImage.Image src={img} key={img} loadingElement={<Spinner />} />);
};

const ModalImageContainer: React.FC<ModalImageContainerProps> = ({
  isOpen,
  onClose,
  images,
  next,
  prev,
  carouselImageIndex,
  setCarouselImageIndex,
  swiperController,
}) => {
  const isSingleImage = typeof images === 'string';
  const device = useDevice();
  usePreventBodyScroll(isOpen);

  // FIXME:
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const ok = {
    next,
    prev,
    carouselImageIndex,
    setCarouselImageIndex,
  };

  // test trigger

  const carouselItems = getCarouselItems(isSingleImage ? [images] : images);

  return (
    <Modal className='modal-image-container' isOpen={isOpen} onClose={onClose} disabledMobileAnimation>
      <Modal.Header onClose={onClose} closeIcon />
      <Modal.Content>
        {isSingleImage ? (
          <div className='image-container'>
            <SwiperCarousel items={carouselItems} swiperProps={{ zoom: true }} hideArrowButtons />
          </div>
        ) : (
          <SwiperCarousel
            items={carouselItems}
            swiperProps={{
              loop: true,
              zoom: true,
              pagination: {
                type: 'fraction',
              },
              allowTouchMove: device.type !== 'desktop',
            }}
            swiperController={swiperController}
            hideArrowButtons={device.type !== 'desktop'}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};

export default React.memo(ModalImageContainer);
